import moment from "moment";
import { REHYDRATE } from "redux-persist";

import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import AbstractApiReducer from "services/cores/abstractApiReducer";
import IndicatorsActionTypes from "./types";
import IndicatorsMapConfig from "./config";

const INITIAL_INDICATORS_STATE = {
  initialized: false,
  data: [],
  indicators: [],
  filters: {
    from: moment().subtract(1, "month").subtract(1, "day").endOf("day"),
    to: moment().subtract(1, "day").endOf("day"),
  },
  config: {
    default_position: undefined,
    default_zoom: 10,
    max_zoom_allowed: 18,
    min_zoom_allowed: 5,
    tiles_url: undefined,
    heatmap_occupancy: undefined,
    currentZoom: 5,
    currentPosition: undefined,
    custom_markers: IndicatorsMapConfig.marker,
  },
};

class IndicatorsReducer extends AbstractApiReducer {
  constructor() {
    super(IndicatorsActionTypes, INITIAL_INDICATORS_STATE);
    this.mapActionToMethods[REHYDRATE] = this.rehydrate;
    this.mapActionToMethods[IndicatorsActionTypes.SET_FILTER] = this.setFilter;
    this.mapActionToMethods[IndicatorsActionTypes.SET_CONFIG_PARAM] =
      this.setConfigParam;
    this.mapActionToMethods[AuthenticationActionTypes.LOG_OUT] =
      this.resetState;
    this.mapActionToMethods[ContractActionTypes.SWITCH_CONTRACT] =
      this.resetState;
    this.mapActionToMethods[IndicatorsActionTypes.SET_DATA] = this.setData;
    this.mapActionToMethods[IndicatorsActionTypes.SET_INITIALIZED] =
      this.setInitialized;
    this.mapActionToMethods[IndicatorsActionTypes.SET_INDICATORS] =
      this.setBackofficeSettingsIndicators;
  }

  rehydrate = (state, action) => {
    return {
      ...INITIAL_INDICATORS_STATE,
      filters: {
        from:
          action?.payload?.Indicators?.filters?.from ??
          INITIAL_INDICATORS_STATE.filters.from,
        to:
          action?.payload?.Indicators?.filters?.to ??
          INITIAL_INDICATORS_STATE.filters.to,
      },
      data: action?.payload?.Indicators?.data ?? [],
    };
  };

  resetState = () => {
    return {
      ...INITIAL_INDICATORS_STATE,
    };
  };

  setFilter = (state, action) => {
    return {
      ...state,
      filters: {
        ...state.filters,
        [action.key]: action.value,
      },
    };
  };

  setConfigParam = (state, action) => {
    return {
      ...state,
      config: {
        ...state.config,
        [action.key]: action.value,
      },
    };
  };

  setData = (state, action) => {
    return {
      ...state,
      data: action.value,
    };
  };

  setBackofficeSettingsIndicators = (state, action) => {
    return {
      ...state,
      indicators: action.value,
    };
  };

  setInitialized = (state, action) => {
    return {
      ...state,
      initialized: action.value,
    };
  };
}

const instance = new IndicatorsReducer();
export default instance.reducer;
